module.exports = __webpack_public_path__ + "img/Blog5.1.86b387bc.png";